module.exports = __webpack_public_path__ + "06_long_black.03ad4d86.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/kanai/female/layer5/06_long_black.png
// module id = W6OC
// module chunks = 0